import { FC } from "react";

import { tableStyles } from "../finance-history-table";

interface HistoryErrorProps {
  message: string;
}

export const HistoryError: FC<HistoryErrorProps> = ({ message }) => (
  <p className={tableStyles.error}>{message}</p>
);
